import { render } from "./Concept_page_en_m.vue?vue&type=template&id=d24932f0&scoped=true"
import script from "./Concept_page_en_m.vue?vue&type=script&lang=js"
export * from "./Concept_page_en_m.vue?vue&type=script&lang=js"

import "./Concept_page_en_m.vue?vue&type=style&index=0&id=d24932f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d24932f0"

export default script